export default "__VITE_ASSET__CciPELU$__"